import React , {useRef , useEffect} from 'react';
import { useFormik } from 'formik';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core';
import { expertValidationSchema } from './expertValidationSchema';
import {
  BaseTypography,
  BaseButton,
  PasswordTextField,
  FormikField,
} from 'src/components/common';
import { APP_ROUTES } from 'src/routing/AppRoutes';
import { IRegisterAsExpert1Model } from 'src/api/base/Auth/types';
import { useFormikErrorsHandler } from 'src/utils/hooks/useFormikErrorsHandler';
import { SocialButtons } from 'src/components/fields/buttons/socialButtons/SocialButtons';
import crypto from 'crypto';

const useStyles = makeStyles((theme) => ({
  form__titleWrapper: {
    marginBottom: '15px',
  },
  formGroup: {
    display: 'grid',
    gridGap: '25px',
  },
  formRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '40px',
    [theme.breakpoints.down('md')]: {
      gridGap: '28px',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  buttons: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, max-content))',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr 1fr',
      gridGap: '28px',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
}));

type PExpertForm = {
  onSubmit: (data: IRegisterAsExpert1Model) => void;
  loading: boolean;
  errors?: any;
};

export const ExpertForm: React.FC<PExpertForm> = (props) => {
  const { onSubmit, loading, errors } = props;
  const classes = useStyles();
  const history = useHistory();
  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      title: '',
      company_name: '',
      password: '',
      password_confirmation: '',
      work_phone: '',
      linkedin: '',
      email: '',
    },
    validationSchema: expertValidationSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
		if(values.email) {
			const current_user_email = values?.email;
			const secretKey = 'tWPVttq9kqAdyHE6yKCiae9zTaB8iGZ2rWEB0vBD'; 
			const userIdentifier = current_user_email; 
			const hash = crypto.createHmac('sha256', secretKey).update(userIdentifier).digest('hex');
			window.Intercom('boot', {
				app_id: 'tl53k1w1',
				email: values?.email,
				user_hash: hash,
				name: `${values.first_name} ${values.last_name}`,
				"First Name": values.first_name,
				"Last Name": values.last_name,
				"Registration Type": 'Expert',
				"Expert Registration Status": 1,
				"ContactsBookAsiaUSer": "ContactsbookAsia",
			});
		}
      onSubmit(values);
      formik.setErrors({});
    },
  });

  const { setFieldError } = formik;

  useFormikErrorsHandler({ errors, setFieldError });

  const ref = useRef<null | HTMLElement>(null);

  useEffect(() => {
    // ref.current?.scrollIntoView({behavior: 'smooth'});
  }, [])

  return (
    <div ref={ref}>
      <div className={classes.form__titleWrapper}>
        <BaseTypography variant="h4">
          Enter an account manager&apos;s info
        </BaseTypography>
        <BaseTypography>
          (enter your own info if you will manage the account yourself)
        </BaseTypography>
      </div>
      <div style={{marginBottom: '20px'}}>
        <SocialButtons />
      </div>
      <form className="registration-form" onSubmit={formik.handleSubmit}>
        <div className={classes.formGroup}>
          <div className={classes.formRow}>
            <FormikField label="First name" name="first_name" formik={formik} />
            <FormikField label="Last name" name="last_name" formik={formik} />
          </div>

          <div className={classes.formRow}>
            <FormikField
              label="Company name"
              name="company_name"
              formik={formik}
            />
            <FormikField label="Title" name="title" formik={formik} />
          </div>

          <div className={classes.formRow}>
            <FormikField label="Email" name="email" formik={formik} />
            <FormikField
              label="Work phone number"
              name="work_phone"
              formik={formik}
              type="number"
            />
          </div>

          <FormikField label="LinkedIn link" name="linkedin" formik={formik} />

          <div className={classes.formRow}>
            <FormikField
              label="Password"
              name="password"
              inputComponent={PasswordTextField}
              formik={formik}
              canHintBeVisible
            />

            <FormikField
              label="Confirm password"
              name="password_confirmation"
              inputComponent={PasswordTextField}
              formik={formik}
            />
          </div>

          <div className={classes.buttons}>
            <BaseButton
              variant="outlined"
              onClick={() => history.push(APP_ROUTES.MAIN)}>
              Back to main page
            </BaseButton>
            <BaseButton type="submit" loading={loading}>
              Next
            </BaseButton>
          </div>
        </div>
      </form>
    </div>
  );
};
